import React from 'react';
import ValidationWrapper from '../validation/ValidationWrapper';


function TextInput({
	name,
	value,
	onChange = () => { },
	colors,
	required,
	checkbbdd,
	/* OPTIONAL PROPS */
	id,
	confirmValue,
	autoComplete = 'off',
	type = 'text',
	placeholder,
	styleINP,
	confirmError,
	classNameINP = 'w-full focus:outline-none text-base md:text-lg',
}) {
	/* Variable that checks if any point of the component focused */
	const [focus, setFocus] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleINP = {
		backgroundColor: colors?.background,
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleINP = { ...defaultStyleINP, ...styleINP };

	/* Handle on focus */
	const onFocus = event => {
		/* This prevents autocomplete on Chrome */
		if (autoComplete === 'off' && event.target.autocomplete) {
			event.target.autocomplete = 'nothing';
		}
		setFocus(true);
	};

	/* Handle on loose focuse */
	const onBlur = () => {
		setFocus(false);
	};

	return <ValidationWrapper
		value={value}
		name={name}
		required={required}
		checkbbdd={checkbbdd}
		colors={colors}
		event={focus}
		showIcons={true}
		confirmValue={confirmValue}
		confirmError={confirmError}
	>
		<input
			className={classNameINP}
			onChange={e => onChange(name === 'dni' ? e.target.value?.toUpperCase() : e.target.value)}
			value={value}
			type={type}
			id={id}
			style={overrideStyleINP}
			placeholder={placeholder}
			autoComplete={autoComplete}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	</ValidationWrapper>;
}

export default TextInput;
